// extracted by mini-css-extract-plugin
module.exports = {"slide-sidebar":"sidebar_slide-sidebar__Cgh3U","sidebar-inner":"sidebar_sidebar-inner__S3SPB","show":"sidebar_show__zImAp"};